"use client";

import type { BillingCurrency } from "../../../convex/lib/billingRail";
import "./unified-checkout.css";

/** USD / TTD switch shared by the plan picker and checkout. USD left, TTD right. */
export function CurrencyToggle({
  currency,
  onChange,
  order = ["USD", "TTD"],
}: {
  currency: BillingCurrency;
  onChange: (next: BillingCurrency) => void;
  /** Button order; default USD then TTD. */
  order?: readonly ("USD" | "TTD")[];
}) {
  return (
    <div className="uc2-currency uc2-currency-toggle" role="radiogroup" aria-label="Currency">
      {order.map((code) => (
        <button
          key={code}
          type="button"
          role="radio"
          aria-checked={currency === code}
          aria-label={code}
          title={code}
          data-no-press=""
          className={currency === code ? "is-selected" : ""}
          onClick={() => onChange(code)}
        >
          <span aria-hidden="true">{code === "USD" ? "🇺🇸" : "🇹🇹"}</span>{" "}
          <span className="uc2-currency-code">{code}</span>
        </button>
      ))}
    </div>
  );
}
